import { useState } from "react";

import { EWizardLegendItemState, type IWizardLegendItems } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import crmEnrichmentTrackingService from "../../services/tracking/trackingService";
import { CrmEnrichmentWizardSteps, type CrmProvider } from "../../types/types";

const STEP_KEYS = ["type", "settings", "filters", "fields-mapping", "review"];

const useWizardSteps = (crmProvider: CrmProvider) => {
    const [activePageIndex, setActivePageIndex] = useState<CrmEnrichmentWizardSteps>(CrmEnrichmentWizardSteps.TypeStep);

    const moveToStep = (index: CrmEnrichmentWizardSteps) => {
        setActivePageIndex(index);
    };

    const goNextStep = () => {
        if (activePageIndex < STEP_KEYS.length - 1) {
            setActivePageIndex((index) => index + 1);
        }
    };

    const goPrevStep = () => {
        if (activePageIndex === CrmEnrichmentWizardSteps.TypeStep) {
            crmEnrichmentTrackingService.wizard.trackClose(CrmEnrichmentWizardSteps.TypeStep, crmProvider);

            void siNavigator.goToCrmManagementPage({ crm: crmProvider });
        } else {
            setActivePageIndex((index) => index - 1);
        }
    };

    const getLegendItemState = (itemIndex: CrmEnrichmentWizardSteps): EWizardLegendItemState => {
        if (itemIndex === activePageIndex) {
            return EWizardLegendItemState.ACTIVE;
        }

        if (itemIndex < activePageIndex) {
            return EWizardLegendItemState.COMPLETED;
        }

        return EWizardLegendItemState.NOT_COMPLETED;
    };

    const legendItems: IWizardLegendItems = STEP_KEYS.map((step, index) => ({
        title: translate(`si.crm-enrichment.job-wizard.legend.${step}`),
        isStepCompleted: false,
        itemState: getLegendItemState(index),
        clickableItemTooltip: "",
        disabledItemTooltip: "",
    }));

    return {
        activePageIndex,
        moveToStep,
        goNextStep,
        goPrevStep,
        legendItems,
    };
};

export default useWizardSteps;
